.caption {
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--muted);
  margin: 0;
}
